import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { Button } from "@/ui";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center px-6 text-center">
      <div className="w-full max-w-md flex flex-col items-center gap-5">
        <div className="flex h-16 w-16 items-center justify-center rounded-full border-2 border-foreground"><X className="h-8 w-8" /></div>
        <h1 data-testid="payment-cancelled" className="text-3xl font-bold">Checkout cancelled.</h1>
        <p className="text-muted-foreground">No charge was made. You can pick up where you left off whenever you're ready.</p>
        <Button data-testid="back-to-paywall" onClick={() => navigate("/paywall")}>Back to subscribe</Button>
      </div>
    </div>
  );
}
